const PatientIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      // className="mb-1"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.87936 22.8C9.21224 22.8 9.55304 22.798 9.90128 22.798H16.4934C16.8411 22.798 17.1819 22.8 17.5148 22.8C20.565 22.8 22.8956 22.644 22.8956 19.4553C22.8956 16.1179 20.3432 13.378 17.0835 13.0802C17.0576 14.2478 13.1984 17.1292 13.1984 17.1292C13.1984 17.1292 9.33824 14.248 9.31208 13.0804C6.05288 13.378 3.5 16.1179 3.5 19.4553C3.5 22.644 5.82968 22.8 8.87936 22.8ZM16.0777 18.4456C16.0777 18.3506 16.1634 18.274 16.2699 18.274H17.3125V17.232C17.3125 17.1264 17.3886 17.0397 17.4836 17.0397H18.5125C18.607 17.0397 18.6836 17.1256 18.6836 17.232V18.2743H19.7257C19.8313 18.2743 19.9177 18.3508 19.9177 18.4459V19.4743C19.9177 19.5693 19.832 19.6459 19.7257 19.6459H18.6834V20.688C18.6834 20.794 18.6066 20.88 18.5118 20.88H17.4834C17.3883 20.88 17.3118 20.7943 17.3118 20.688V19.6456H16.2697C16.1636 19.6456 16.0774 19.5691 16.0774 19.474L16.0777 18.4456Z"
        fill="#18357A"
        fillOpacity="1"
      />
      <path
        d="M13.1997 13.918C16.1478 13.918 18.5375 9.48499 18.5375 6.53707C18.5375 3.58963 16.1478 1.19995 13.1997 1.19995C10.252 1.19995 7.8623 3.58963 7.8623 6.53707C7.8623 9.48499 10.252 13.918 13.1997 13.918Z"
        fill="#18357A"
        fillOpacity="1"
      />
    </svg>
  );
}

export default PatientIcon